import { render, staticRenderFns } from "./FriendlyIdEdit.vue?vue&type=template&id=534b49f0&scoped=true"
import script from "./FriendlyIdEdit.vue?vue&type=script&lang=ts"
export * from "./FriendlyIdEdit.vue?vue&type=script&lang=ts"
import style0 from "./FriendlyIdEdit.vue?vue&type=style&index=0&id=534b49f0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534b49f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('534b49f0')) {
      api.createRecord('534b49f0', component.options)
    } else {
      api.reload('534b49f0', component.options)
    }
    module.hot.accept("./FriendlyIdEdit.vue?vue&type=template&id=534b49f0&scoped=true", function () {
      api.rerender('534b49f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/FriendlyIdEdit.vue"
export default component.exports